import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppIcons } from '@core/utilities/icons';
import { PersonasAuthService } from '../../services/personas-auth.service';

export interface SidebarNavItem {
    label: string;
    link: string;
    icon: keyof typeof AppIcons;
    exact?: boolean;
    showDot?: boolean;
}

@Component({
    selector: 'app-personas-sidebar',
    standalone: true,
    imports: [CommonModule, RouterModule, FontAwesomeModule],
    templateUrl: './personas-sidebar.component.html',
    styleUrls: ['./personas-sidebar.component.scss']
})
export class PersonasSidebarComponent {
    readonly icons = AppIcons;

    /** Mockup: enlaces con icono teal, activo con fondo suave y check */
    readonly menuItems: SidebarNavItem[] = [
        { label: 'Inicio', link: '/personas/inicio', icon: 'fasHome', exact: true },
        // { label: 'Documentos', link: '/personas/documentos-credito', icon: 'falFileLines', showDot: true },
        { label: 'Mi perfil', link: '/personas/mis-datos', icon: 'falUser' }
    ];

    readonly soporteMail = 'mailto:servicioalcliente@corecredit.co';

    private readonly router = inject(Router);
    private readonly personasAuthService = inject(PersonasAuthService);

    logout(): void {
        this.personasAuthService.logout();
    }
}
